import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/Dashboard';

function Dashboard() {
  return (
    <MainInfoTracLayout>
      <Content />
    </MainInfoTracLayout>
  );
}

export default Dashboard;
